import {
    IAtendimentoVinculado,
    IVincularAtendimento,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoVinculado/AtendimentoVinculadoInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";

interface IAtendimentoCriadoResponse {
    IDResponse: number;
}

export function ListarAtendimentosVinculadosService(idCaso: number) {
    return Service(
        Axios.get<Array<IAtendimentoVinculado>>(
            `/assistenciatecnica/atendimentovinculado/listaratendimentosvinculados?idCaso=${idCaso}`
        )
    );
}

export function AbrirAtendimentoVinculadoService(
    abriratendimentovinculado: IVincularAtendimento
) {
    return Service(
        Axios.post<IAtendimentoCriadoResponse>(
            `/assistenciatecnica/atendimentovinculado/abriratendimentovinculado`,
            abriratendimentovinculado
        )
    );
}
